<template>
    <div>
        <!--<div class="m-portlet">-->
        <!--<div class="m-portlet__body">-->
        <!--<el-tabs v-model="activeName">-->
        <!--<el-tab-pane label="学校考试" name="first"></el-tab-pane>-->
        <!--                    <el-tab-pane label="机构考试" name="second"><OrganizationServiceExam></OrganizationServiceExam></el-tab-pane>-->
        <!--</el-tabs>-->
        <SchoolExam></SchoolExam>
        <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>
    import SchoolExam from './SchoolExamList.vue';
    import OrganizationServiceExam from './OrganizationServiceExam.vue';

    export default {
        name: "index",
        data() {
            return {
                activeTab: 1,
                activeName: 'first',
                schoolExamList: {}

            }
        },
        components: {
            SchoolExam,
            OrganizationServiceExam,
        },
        created() {
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            }
        },
        methods: {}
    }
</script>

<style scoped>

</style>
